import React, { useRef, useEffect, useState } from 'react';
import './Conference.css';

// Import conference photos
import photo1 from '../assets/images/20232024conferencephotos/1.png';
import photo2 from '../assets/images/20232024conferencephotos/2.png';
import photo3 from '../assets/images/20232024conferencephotos/3.png';
import photo4 from '../assets/images/20232024conferencephotos/4.png';
import photo5 from '../assets/images/20232024conferencephotos/5.png';
import photo6 from '../assets/images/20232024conferencephotos/6.png';
import photo7 from '../assets/images/20232024conferencephotos/7.png';
import photo8 from '../assets/images/20232024conferencephotos/8.png';
import photo9 from '../assets/images/20232024conferencephotos/9.png';
import photo10 from '../assets/images/20232024conferencephotos/10.png';
import photo11 from '../assets/images/20232024conferencephotos/11.png';
import photo12 from '../assets/images/20232024conferencephotos/12.png';

const Conference = () => {
  const galleryRef1 = useRef(null);
  const galleryRef2 = useRef(null);
  const heroRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Check if mobile
    const checkIfMobile = () => setIsMobile(window.innerWidth <= 768);
    checkIfMobile();
    
    // Add resize listener
    window.addEventListener('resize', checkIfMobile);
    
    // Auto-scroll to hero section
    heroRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });

    // Only run animation on desktop
    if (!isMobile && galleryRef1.current && galleryRef2.current) {
      const gallery1 = galleryRef1.current;
      const gallery2 = galleryRef2.current;
      
      gallery1.innerHTML += gallery1.innerHTML;
      gallery2.innerHTML += gallery2.innerHTML;

      const animate = () => {
        if (gallery1.offsetLeft <= -gallery1.scrollWidth / 2) gallery1.style.left = '0';
        if (gallery2.offsetLeft >= 0) gallery2.style.left = -gallery2.scrollWidth / 2 + 'px';
        
        gallery1.style.left = gallery1.offsetLeft - 1 + 'px';
        gallery2.style.left = gallery2.offsetLeft + 1 + 'px';
        
        requestAnimationFrame(animate);
      };

      animate();
    }

    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, [isMobile]);

  const conferencePhotos = [
    photo1, photo2, photo3, photo4, photo5, 
    photo6, photo7, photo8, photo9, photo10,
    photo11, photo12
  ];

  return (
    <div className="conference-container">
      <div className="conference-page">
        <section className="conference-hero" ref={heroRef}>
          <div className="conference-hero-content">
            <h1>The 7th Clean Air Conference 2026</h1>
            <p className="conference-subtitle">
              Asia's Largest Student-led Clean Air Conference, With Full Support From {' '}
              <a href="https://hongkongcan.org" target="_blank" rel="noopener noreferrer">
                Clean Air Network
              </a>
            </p>
            <p className="conference-date">18 April 2026</p>
            <p className="conference-description">
              Be there for insightful sessions led by doctors, scientists, and industry experts at the forefront of the clean air movement. Engage with professionals from government, medicine, architecture, business, and non-profit sectors and connect with like-minded peers from the student community. All at no cost.
            </p>
            <div className="conference-buttons">
              <a 
                href="https://forms.gle/JegMgJyJmjgGyPeXA" 
                target="_blank" 
                rel="noopener noreferrer"
                className="conference-button apply-button"
              >
                Apply Now
              </a>
              <a 
                href="https://issuu.com/cleanairstudentcouncilhongkong/docs/clean_air_conference_2025_program_booklet" 
                target="_blank" 
                rel="noopener noreferrer"
                className="conference-button booklet-button"
              >
                Program Booklet
              </a>
            </div>
          </div>
        </section>

        <section className="conference-gallery">
          <div className="gallery-track" ref={galleryRef1}>
            {conferencePhotos.map((photo, index) => (
              <div className="gallery-item" key={`g1-${index}`}>
                <img src={photo} alt={`Conference ${index + 1}`} loading="lazy" />
              </div>
            ))}
          </div>
          <div className="gallery-track reverse" ref={galleryRef2}>
            {conferencePhotos.map((photo, index) => (
              <div className="gallery-item" key={`g2-${index}`}>
                <img src={photo} alt={`Conference ${index + 1}`} loading="lazy" />
              </div>
            ))}
          </div>
        </section>

        <section className="conference-details">
          <h2>Conference Details</h2>
          <div className="details-grid">
            <div className="detail-item">
              <h3>Date</h3>
              <p>April 18, 2026 (Sat)</p>
            </div>
            <div className="detail-item">
              <h3>Time</h3>
              <p>9:30 AM - 12:10 PM <br />(Registration opens at 9 AM)</p>
            </div>
            <div className="detail-item">
              <h3>Location</h3>
              <p>ESF Island School<br />20 Borrett Road, Mid-levels, Hong Kong</p>
            </div>
            <div className="detail-item">
              <h3>Theme</h3>
              <p>Breathing the Future: A Clean Sky For Lifelong Health</p>
            </div>
            <div className="detail-item">
              <h3>Fee</h3>
              <p>Free of charge</p>
            </div>
            <div className="detail-item">
              <h3>How to apply</h3>
              <p>Apply via this <a href="https://forms.gle/JegMgJyJmjgGyPeXA" target="_blank" rel="noopener noreferrer">form</a> by 1 April 2026</p>
            </div>
          </div>
          <div className="keynote-speaker">
            <p>
              ❗️Keynote Speaker of the Year: Professor Ken Yung Kin-lam is a Professor of Biology and Neuroscience at the Education University of Hong Kong researching on the relationship between the environmental toxicology and neuroscience.

Over the years, Prof Ken Yung's research has received numerous prestigious international invention, and innovation awards such Gold Metals in Geneva Invention. Prof. Yung's team has long been dedicated to cutting-edge interdisciplinary research in neuroscience and translational medicine. Their work focuses on original and systematic studies in areas including the pathogenesis of neurodegenerative diseases, brain health and injury repair, environmental exposure and neurotoxicology, stem cell and regenerative medicine, and applications of intelligent nanomaterials. Characterized by multidisciplinary integration and innovation, the team utilizes advanced approaches such as molecular biology, nano-biomaterial engineering, and 3D organoid construction.

These methods drive multidimensional breakthroughs in understanding neurological disease mechanisms, protecting brain health, assessing environmental health risks, and developing novel intervention strategies.
Their research spans fundamental discoveries to preclinical to potential clinical applications, making significant contributions to addressing major health challenges. Prof. Yung is ranked among Stanford World's Top 2% Scientists and awarded over 20 international patents.
            </p>
          </div>
          
          <div className="about-casc">
            <h2>About Clean Air Student Council</h2>
            <p>
              Established in 2019, Clean Air Student Council is the youth branch of the Clean Air Network, 
              representing students from over 10 schools in Hong Kong. To date, CASC has empowered more than 
              1000 students and stands as the largest student clean air advocacy group in the city.
            </p>
            <a 
              href="https://byeigostudy.wixsite.com/casc/blog/categories/clean-air-conference" 
              target="_blank" 
              rel="noopener noreferrer"
              className="casc-link"
            >
              Learn more about our past conferences est. 2019 &gt;
            </a>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Conference;